import { 
  RESERVATION_POST_RESERVE_INTERVAL, 
  RESERVATION_PUT_CONFIRM,
  RESERVATION_DELETE_FREE_INTERVAL,
  RESERVATION_CLICK_CONFIRM_BTN,
  RESERVATION_CHANGE_INPUT,
  RESERVATION_TIME_EXPIRATION,
  PENDING, FULFILLED, REJECTED,
  CONTROLLED_INPUT_NORMAL, CONTROLLED_INPUT_VALID, CONTROLLED_INPUT_INVALID,
  INTERVALS_GET_OFFICE_INFO,
} from '../globals';


export const initialState = {
  reserveData: {
    isLoading: false,
    status: false,
    error: false,
    errorType: '',
    data: {},
    errorMessage: {},
  },
  confirmData: {
    isLoading: false,
    error: false,
  },
  deleteReservationData : {
    isLoading: false,
  },
  officeData: {
    isLoading: false,
    status: false,
    data: {},
    error: false,
    errorMessage: {},
  },
  reservationState: {
    // 0 - noraml, 
    // 1 - succes, 
    // 2 - error, 
    phase: 0, 
    inputs: {
      name: '',
      email: '',
      phone: '',
      note: '',
      agreement: false,
      agreementValid: CONTROLLED_INPUT_NORMAL,
      captcha: null,
      captchaValid: CONTROLLED_INPUT_NORMAL, 
      nameValid: CONTROLLED_INPUT_NORMAL, 
      emailValid: CONTROLLED_INPUT_NORMAL, 
      phoneValid: CONTROLLED_INPUT_NORMAL,
      noteValid: CONTROLLED_INPUT_NORMAL,
    },
    success: {
      storeName: '', 
      storeAddress: '',
      serviceName: '',
      reservedTime: '',
      emailConfirmation: false,
      pin: '',
    }, 
    error: {
      blacklist: true,
      timeLimit: true,
      nonDuplicatedEmail: true,
    }
  },
};


const successConfirm = (state, payload) => {
  const { store_name, store_address, service_name, time, email_confirmation, pin } = payload.data;

   const newState = {
    ...state,
    confirmData: {
      ...state.confirmData,
      isLoading: false,
      error: false,
    },
    reservationState: {
      ...state.reservationState,
      phase: 1,
      inputs: {
          ...state.reservationState.inputs,
        nameValid: CONTROLLED_INPUT_NORMAL, 
        emailValid: CONTROLLED_INPUT_NORMAL, 
        phoneValid: CONTROLLED_INPUT_NORMAL,
      },
      success: {
        storeName: store_name, 
        storeAddress: store_address,
        serviceName: service_name,
        reservedTime: time,
        emailConfirmation: email_confirmation,
        pin: pin,
      }, 
    },
  }; 

  return newState;
}


const errorConfirm = (state, payload) => {
  if (payload.message !== undefined) {
    const { email, name, phone_number, time, blacklist, non_duplicated_email, other } =  payload.message.data.message.message;

    // CHYBA - false
    const newPhase = time ? 0 : 2;  

    const newState = {
      ...state,
      confirmData: {
        ...state.confirmData,
        isLoading: false,
        error: true,
      },
      reservationState: {
        ...state.reservationState,
        phase: newPhase,
        inputs: {
            ...state.reservationState.inputs,
          nameValid: name ? CONTROLLED_INPUT_VALID : CONTROLLED_INPUT_INVALID, 
          emailValid: email ? CONTROLLED_INPUT_VALID : CONTROLLED_INPUT_INVALID, 
          phoneValid: phone_number ? CONTROLLED_INPUT_VALID : CONTROLLED_INPUT_INVALID, 
        },
        error: {
          blacklist: blacklist,
          timeLimit: time,
          nonDuplicatedEmail: non_duplicated_email,
        }
      },
    }; 

    return newState;
  }

  const newState = {
    ...state,
    confirmData: {
      ...state.confirmData,
      isLoading: false,
      error: true,
    },
    reservationState: {
      ...state.reservationState,
      phase: 0,
      error: initialState.reservationState.error,
    },
  }; 

  return (newState);
}


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${RESERVATION_POST_RESERVE_INTERVAL}_${PENDING}`:
      return {
        ...initialState,
        reserveData: {
          ...initialState.reserveData,
          isLoading: true,
        }
      };

    case `${RESERVATION_POST_RESERVE_INTERVAL}_${FULFILLED}`:
      return {
        ...state,
        reserveData: {
          ...state.reserveData,
          isLoading: false,
          status: action.payload.status,
          data: action.payload.data,
        }
      };

    case `${RESERVATION_POST_RESERVE_INTERVAL}_${REJECTED}`:
      return {
        ...state,
        reserveData: {
          ...state.reserveData,
          isLoading: false,
          status: false,
          error: true,
          errorType: (action.payload.message && action.payload.message.data.message.message && action.payload.message.data.message.message.full === false) ? 'full' : '',
          errorMessage: action.payload.error,
        }
      };
    
    

    case `${RESERVATION_PUT_CONFIRM}_${PENDING}`:
      return {
        ...state,
        confirmData: {
          ...state.confirmData,
          isLoading: true,
          error: false,
        }
      };

    case `${RESERVATION_PUT_CONFIRM}_${FULFILLED}`:
      if (action.payload.status) {
        return successConfirm(state, action.payload);
      }
      return errorConfirm(state, action.payload);

        
    case `${RESERVATION_PUT_CONFIRM}_${REJECTED}`:      
      return errorConfirm(state, action.payload);


    case `${RESERVATION_DELETE_FREE_INTERVAL}_${PENDING}`:
      return {
        ...state,
        deleteReservationData: {
          ...state.deleteReservationData,
          isLoading: true,
        }
      };

    case `${RESERVATION_DELETE_FREE_INTERVAL}_${FULFILLED}`:
      return {
        ...state,
        deleteReservationData: {
          ...state.deleteReservationData,
          isLoading: false,
        }
      };

    case `${RESERVATION_DELETE_FREE_INTERVAL}_${REJECTED}`: 
      return {
        ...state,
        deleteReservationData: {
          ...state.deleteReservationData,
          isLoading: false,
        }
      };


    
    case `${RESERVATION_CLICK_CONFIRM_BTN}`: 
      return {
        ...state,
        reservationState: {
          ...state.reservationState,
          inputs: {
            ...state.reservationState.inputs,
            nameValid: action.payload.nameValid, 
            emailValid: action.payload.emailValid, 
            phoneValid: action.payload.phoneValid,
            noteValid: action.payload.noteValid,
            agreementValid: action.payload.agreementValid,
            captchaValid: action.payload.newCaptcha,
          },
        }
      };

    case `${RESERVATION_CHANGE_INPUT}`:
      return {
        ...state,
        reservationState: {
          ...state.reservationState,
          inputs: {
            ...state.reservationState.inputs,
            [action.payload.inputName]: action.payload.value,
            [action.payload.inputName + 'Valid']: CONTROLLED_INPUT_NORMAL,
          },
        }
      };

    case `${RESERVATION_TIME_EXPIRATION}`:
      return {
        ...state,
        reservationState: {
          ...state.reservationState,
          phase: 2, 
          error: {
            blacklist: true,
            timeLimit: false,
            nonDuplicatedEmail: true,
          }
        }
      }

    case `${INTERVALS_GET_OFFICE_INFO}_${PENDING}`:
      return {
        ...state,
        officeData: {
          ...state.officeData,
          isLoading: true,
        }
      };

    case `${INTERVALS_GET_OFFICE_INFO}_${FULFILLED}`:
      return {
        ...state,
        officeData: {
          ...state.officeData,
          isLoading: false,
          status: action.payload.status,
          data: action.payload.data,
        }
      };

    case `${INTERVALS_GET_OFFICE_INFO}_${REJECTED}`: 
      return {
        ...state,
        officeData: {
          ...state.officeData,
          isLoading: false,
          status: false,
          error: true,
          errorMessage: action.payload.error,
        }
      };

    default:
      return state;
  }
};

export default reducer;
